import { createFileRoute } from '@tanstack/react-router';
import LibraryListComponent from 'src/Administration/PageContent/PageContentLibrary/LibraryList/LibraryList';

export const Route = createFileRoute('/systemadmin/_layout/page-content/library/list')({
  component: LibraryListComponent,
});
